import { Duration } from 'luxon';
const relationships = [.2, .7, 1.4];
const membershipBoost = .45;
const approximateFees = .15;
const PRICING_STRATEGIES = {
    PROFIT: 1,
    BREAKEVEN: 0
};
const calculateDefaultCurationValue = (period, frequency, monthlyPrice) => {
    var _a;
    return ((_a = Duration.fromObject({ [period]: frequency }).shiftTo("months")) === null || _a === void 0 ? void 0 : _a.months) * monthlyPrice / 100 || 0;
};
// https://www.w3resource.com/javascript-exercises/javascript-basic-exercise-140.php
const test_same_digit = (num) => {
    var first = num % 10;
    while (num) {
        if (num % 10 !== first)
            return false;
        num = Math.floor(num / 10);
    }
    return true;
};
const calculateTiers = (averageOrderValue, customerVisitFrequency, strategy = PRICING_STRATEGIES.PROFIT, subscriptionMode = false) => {
    if (averageOrderValue < 1000)
        averageOrderValue = 1000;
    if (customerVisitFrequency < 1)
        customerVisitFrequency = 1;
    // Create calculated tiers
    const tiers = relationships.map((relationship, relationshipIndex) => {
        let price = Math.round(relationship * averageOrderValue);
        let discount = Math.round((price * (1 - approximateFees)) / (averageOrderValue * customerVisitFrequency * (1 + strategy) * (1 + membershipBoost)) * 100);
        // Test if price is all the same digit, otherwise round to nearest 5 or 10
        if (!test_same_digit(price)) {
            price = Math.round(price / 5) * 5;
        }
        // Test if discount is all the same digit, otherwise round to nearest 5 or 10
        if (!test_same_digit(discount)) {
            discount = Math.round(discount / 5) * 5;
        }
        return ({
            price: price,
            discount: discount
        });
    });
    if (subscriptionMode)
        tiers[tiers.length - 1].discount = tiers[tiers.length - 2].discount;
    return tiers;
};
const calculateDefaultRebate = (averageOrderValue, customerVisitFrequency, strategy = PRICING_STRATEGIES.PROFIT) => {
    return Math.round(calculateTiers(averageOrderValue, customerVisitFrequency, strategy)[1].discount / 100 * averageOrderValue);
};
// TODO - move to Jest 
// console.log(calculateTiers(100, 1.25, PRICING_STRATEGIES.PROFIT)) // $140 @ 33$, $70 @ 16%, $20 @ 5%
// console.log(calculateTiers(350, 1.67, PRICING_STRATEGIES.BREAKEVEN)) // $490 @ 49%, 245 @ 25%, $70 @ 7%
// console.log(calculateTiers(7.50, 3, PRICING_STRATEGIES.BREAKEVEN)) // $11 @ 27%, $5 @ 13%, $2 @ 5%
// console.log(calculateTiers(15, 1.15, PRICING_STRATEGIES.PROFIT)) // $21 @ 36%, $11 @ 19%, $3 @ 5%
// console.log(calculateTiers(15, 1.15, PRICING_STRATEGIES.PROFIT)) // $21 @ 36%, $11 @ 19%, $3 @ 5%
// console.log(calculateTiers(15, 1.15, PRICING_STRATEGIES.PROFIT, true)) // $21 @ 19%, $11 @ 19%, $3 @ 5%
export { calculateTiers, PRICING_STRATEGIES, calculateDefaultRebate, calculateDefaultCurationValue };
